import { useState } from "react";
import {
  DecompositionGame,
  GameSelector,
  Login,
  MultiplesGame,
  PlaceValueGame,
  RecipeZone,
  SchulteGridGame,
  SumToTenGame,
} from "./components";
import { GameProvider, useGame } from "./context";
import "./MathZoo.css";

// 遊戲路由組件
const GameRouter = () => {
  const { state, actions } = useGame();
  const [currentGame, setCurrentGame] = useState(null);

  // 未登入顯示登入頁面
  if (!state.isLoggedIn) {
    return <Login />;
  }

  // 正在進行遊戲
  if (currentGame) {
    const handleBack = () => {
      setCurrentGame(null);
      actions.endGame();
    };

    switch (currentGame) {
      case "decomposition":
        return <DecompositionGame onBack={handleBack} />;
      case "placeValue":
        return <PlaceValueGame onBack={handleBack} />;
      case "multiples":
        return <MultiplesGame onBack={handleBack} />;
      case "schulteGrid":
        return <SchulteGridGame onBack={handleBack} />;
      case "sumToTen":
        return <SumToTenGame onBack={handleBack} />;
      case "recipeZone":
        return <RecipeZone onBack={handleBack} />;
      default:
        return (
          <GameSelector
            onSelectGame={setCurrentGame}
            onLogout={actions.logout}
          />
        );
    }
  }

  // 顯示遊戲選擇器
  return (
    <GameSelector onSelectGame={setCurrentGame} onLogout={actions.logout} />
  );
};

// 反饋提示組件
const FeedbackToast = () => {
  const { state } = useGame();

  if (!state.feedback) return null;

  const typeStyles = {
    success: { background: "#4CAF50", icon: "✓" },
    error: { background: "#f44336", icon: "✗" },
    warning: { background: "#ff9800", icon: "!" },
    info: { background: "#2196F3", icon: "ℹ" },
  };

  const style = typeStyles[state.feedback.type] || typeStyles.info;

  return (
    <div className="feedback-toast-overlay">
      <div className="feedback-toast" style={{ background: style.background }}>
        <span className="toast-icon">{style.icon}</span>
        <span className="toast-message">{state.feedback.message}</span>
      </div>
    </div>
  );
};

// 主應用組件
const MathZoo = () => {
  return (
    <GameProvider>
      <div className="math-zoo-app">
        <GameRouter />
        <FeedbackToast />
      </div>
    </GameProvider>
  );
};

export default MathZoo;
